import "./App.css";
import CesiumJS from "./page/CesiumJS";

import { Route, BrowserRouter, Routes } from "react-router-dom";
import Layout from "./components/layout/Layout";
import Project from "./page/Project";

import TaskListPage from "./page/TaskListPage";
import QualityCheckPage from "./page/QualityCheckPage";
import TaskCreatePage from "./page/TaskCreatePage";
import LoginPage from "./page/LoginPage";
import PotreeViewer2 from "./page/PotreeViewer2";
import RegisterPage from "./page/RegisterPage";
import AlertModal from "./components/modal/AlertModal";
import { useCustomAlertStore, useSearchStore } from "./Store/store";
import ProjectCreatePage from "./page/ProjectCreatePage";
import CesiumPage from "./page/CesiumPage";
import SearchModal from "./components/modal/SearchModal";
import UserManagementPage from "./page/UserManagementPage";
import FindPasswordPage from "./page/FindPasswordPage";
import ResetPasswordPage from "./page/ResetPasswordPage";
import CompanyRequestPage from "./page/CompanyRequestPage";
import PotreeViewer3 from "./page/PotreeViewer3";
import PotreeViewer from "./page/PotreeViewer";
import PathInfoModal from "./components/PotreeUtil/PathInfoModal";
import {
  AutovehicleSpecsStore,
  PotreeGenerateAreaStore,
  usePathInfoModalStore,
  usePathModeStore,
  usePotreeStore,
} from "./Store/PotreeStore";
import { usePathStore } from "./Store/store";

function App() {
  const { isCustomAlertOpen } = useCustomAlertStore();
  const { isSearchOpen } = useSearchStore();
  const { isOpen: isPathInfoOpen, close: closePathInfoModal } =
    usePathInfoModalStore();

  // 모달이 어디서 열리든, App에서 현재 상태를 읽어 모달에 주입
  const { SelectionGenerateMode, fullPathStore } = usePathModeStore();
  const { potreeViewer } = usePotreeStore();
  const { viewer } = usePathStore();
  const { pathMode, direction } = PotreeGenerateAreaStore();
  const { WorkMode, interval, size } = AutovehicleSpecsStore();

  const activeViewer = SelectionGenerateMode === "auto" ? potreeViewer : viewer;

  return (
    <BrowserRouter>
      <Routes>
        {/* 인증이 필요없는 페이지들 */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/find-password" element={<FindPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/company-request" element={<CompanyRequestPage />} />

        {/* 인증이 필요한 페이지들 - Layout으로 감싸기 */}
        <Route path="/" element={<Layout />}>
          <Route index element={<CesiumPage />} />
          <Route path="/potree/:projectId/:fileId" element={<PotreeViewer />} />
          <Route path="/project" element={<Project />} />
          <Route path="/project/task/:id" element={<TaskListPage />} />
          <Route path="/quality-check/:id" element={<QualityCheckPage />} />
          <Route path="/task/create/:id" element={<TaskCreatePage />} />
          <Route path="/project/create" element={<ProjectCreatePage />} />
          <Route path="/user-management" element={<UserManagementPage />} />
        </Route>
      </Routes>

      {/* 전역 알림 모달 - 모든 페이지에서 사용 가능 */}
      {isCustomAlertOpen && <AlertModal />}
      {isSearchOpen && <SearchModal />}
      <PathInfoModal
        isOpen={isPathInfoOpen}
        onClose={closePathInfoModal}
        activeViewer={activeViewer}
        fullPathStore={fullPathStore}
        options={{
          pathMode,
          direction,
          workMode: WorkMode,
          interval,
          size,
        }}
      />
    </BrowserRouter>
  );
}

export default App;
